import { useParams } from "next/navigation";
import { OfferDigitalSubscription } from "types";
import { useIsAllocationDisabledQuery } from "./operations.generated";

function useIsAllocationDisabled() {
	const { slug } = useParams<{ slug?: string }>();

	const { data } = useIsAllocationDisabledQuery({
		variables: {
			slug: slug!,
		},
		skip: !slug,
	});

	if (data?.offer?.digitalSubscription === OfferDigitalSubscription.Disabled) {
		return true;
	}

	return false;
}

export default useIsAllocationDisabled;
